import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";

import {
  getTestData,
  downloadTestData,
  getYieldTestData,
  getAmortTestData,
  downloadAmortTestData
} from "store/state/calculators/testHarness";
import {
  LIBOR_FORWARD_CURVE,
  CAP_VOLS,
  MARKET_EXPECTATIONS_SHOCK,
  TREASURIES,
  PARALLEL_SHOCK,
  BASE_POINTS_DIVISOR
} from "../Constants/Constants";
import CalculatorTestHarnessSearch from "./Curves/CalculatorTestHarnessSearch";
import ResultTable from "./Curves/ResultTable";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class ForwardCurveNew extends Component {
  state = {
    dayOfMonth: new Date().getDate(),
    curve: LIBOR_FORWARD_CURVE,
    shockType: MARKET_EXPECTATIONS_SHOCK,
    shockValue: 0,
    baseDate: moment(),
  };

  tablePaginationHelper = new TablePaginationHelper("618718d6-f229-4f51-acd1-9b847032895f", 10);

  submit = () => {
    const options = { ...this.state, page: this.tablePaginationHelper.page, pageSize: this.tablePaginationHelper.rowsPerPage };
    options.baseDate = options.baseDate.format("YYYY-MM-DD");
    if(options.shockType === PARALLEL_SHOCK) {
      options.shockValue = parseInt(options.shockValue, 10) / BASE_POINTS_DIVISOR;
    }
    this.props.getTestData(options);
  };

  downloadTestData = () => {
    const options = { ...this.state, page: -1, pageSize: -1 };
    this.props.downloadTestData(options);
  };


  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value
    });

    if (name === "shockType" && value === MARKET_EXPECTATIONS_SHOCK) {
      this.setState({
        shockValue: 0
      });
    } else if (name === "curve" && value === CAP_VOLS) {
      this.setState({
        shockType: MARKET_EXPECTATIONS_SHOCK
      });
    }
    this.props.testHarness.testData = null;
  };

  handleDateChange = date => {
    this.setState({
      baseDate: date
    });
  };

  handleChangePage = (event, newPage) => {
    if (!event) {
      return null;
    }

    this.tablePaginationHelper.page = newPage;
    this.submit();
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.submit();
  };

  render() {
    return (
      <Fragment>
        <CalculatorTestHarnessSearch
          submit={this.submit}
          downloadTestData={this.downloadTestData}
          handleChange={this.handleChange}
          handleDateChange={this.handleDateChange}
          state={this.state}
        />
        <ResultTable
          submit={this.submit}
          handleChange={this.handleChange}
          handleDateChange={this.handleDateChange}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          state={this.state}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, testHarness }) => ({
  authentication,
  testHarness
});

export default compose(
  connect(
    mapStateToProps,
    {
      getTestData,
      downloadTestData,
      getYieldTestData,
      getAmortTestData,
      downloadAmortTestData
    }
  )
)(ForwardCurveNew);
